// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blur-block[data-v-ca06480c] {
  position: absolute;
  overflow: hidden;
  object-fit: cover;
  height: 100%;
  width: 100%;
  filter: blur(4px);
}
.preview-block[data-v-ca06480c] {
  position: relative;
}
.preview-block .img-wrapper img[data-v-ca06480c] {
  height: var(--imgHeight);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/channels/PublicationImageItem.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[".blur-block[data-v-ca06480c] {\n  position: absolute;\n  overflow: hidden;\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n  filter: blur(4px);\n}\n.preview-block[data-v-ca06480c] {\n  position: relative;\n}\n.preview-block .img-wrapper img[data-v-ca06480c] {\n  height: var(--imgHeight);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
